import {useEffect, useMemo, useState} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import Table from '../../../common/table/TableFunctional';
import {shortenText} from '../../../common/shared/statelessMethods';
import { constants } from '../../../common/constants/constants';
import MonthTableLogic from '../table/monthTableLogic';
import {hideLoader, showLoader} from '../../../store/common/slice';
import {Currency} from "../../../common/currency";

export default function MonthlyData({filters, apartmentNumber, data, buildingID}) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [loadingStarted, setLoadingStarted] = useState(false);

    useEffect(() => {
        if (!loadingStarted && !data.rows) {
            dispatch(showLoader());
            setLoadingStarted(true);
        }
        if (loadingStarted && data.rows) {
            dispatch(hideLoader());
            setLoadingStarted(false);
        }
    }, [data]);

    const columnsMonth = useMemo(
        () => {
            const stableDataColumns = [
                {
                    accessor: 'title',
                },
                {
                    Header: t('reports.tenantName'),
                    Cell: ({value}) =>  {
                        // todo duplicate code. unify
                        value = value && value.map(r => `${r.tenantName} ${r.tenantType === 'unknown' ? '' : `(${t(`reports.tenantType.${r.tenantType}`)})`}`).join(', ');
                        let text = shortenText(value);
                        return (
                            <OverlayTrigger
                                placement="top"
                                overlay={props => (
                                    <Tooltip {...props}>
                                        {text?.originalComment}
                                    </Tooltip>
                                )}
                            >
                                <span exceltext={text?.originalComment || text}>{text?.shortComment || text}</span>
                            </OverlayTrigger>
                        );
                    },
                    accessor: 'tenantName',
                }
            ];

            const monthColumns = constants.months.map(monthInt => {
                const label = t(`common.months.${monthInt}`);
                return {
                    id: label,
                    Header: () => (<span>{label}</span>),
                    Cell: ({ row }) => {
                        let value;
                        if (row.original[constants.MonthsToText[monthInt]] && row.original.key === 'paid') value = row.original[constants.MonthsToText[monthInt]].paid.value + row.original[constants.MonthsToText[monthInt]].scheduled_to_pay.value;
                        else if (row.original[constants.MonthsToText[monthInt]]) value = row.original[constants.MonthsToText[monthInt]][row.original.key].value;
                        return <div>{value}</div>
                    }
                }
            });

            const totalColumns = [
                {
                    Header: t('reports.total_charged'),
                    accessor: 'total.charged.value',
                    Cell: ({row, value}) => row.original.total ? (<span exceltext={value}>{value}<Currency>{row.original.total.charged.currency}</Currency></span>) : '',
                },
                {
                    Header: t('reports.total_debt_col'),
                    accessor: 'total.debt.value',
                    Cell: ({row, value}) => row.original.total ? (<span exceltext={value}>{value}<Currency>{row.original.total.debt.currency}</Currency></span>) : '',
                },
                {
                    Header: t('reports.total_future'),
                    accessor: 'total.future.value',
                    Cell: ({row, value}) => row.original.total ? (<span exceltext={value}>{value}<Currency>{row.original.total.future.currency}</Currency></span>) : '',
                }
            ];

            return stableDataColumns.concat(monthColumns).concat(totalColumns);
        },
        [data]
    );

    return data.rows && data.rows.length > 0 ? (
        <>
            <Table
                buildingId={buildingID}
                className={'new-report monthly'}
                columns={columnsMonth}
                data={data.rows}
                filters={filters}
                tableTitle={t('reports.apartment_cashflow_title', {apartmentNumber})}
                disableSort
            />
        </>
    ) : (<h2 className='text-center'>{t('reports.empty_table')}</h2>);
}
